import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const SERVICES = [
  { slug: "laparoscopic-hernia-surgery-vijayawada", title: "Laparoscopic Hernia Surgery", shortDesc: "Advanced minimally invasive hernia repair with faster recovery and minimal scarring.", image: "/images/services/laparoscopic-hernia-surgery.webp" },
  { slug: "laparoscopic-gallbladder-surgery-vijayawada", title: "Laparoscopic Gallbladder Surgery", shortDesc: "Safe and effective gallbladder removal using keyhole surgery for gallstones.", image: "/images/services/laparoscopic-gallbladder-surgery.webp" },
  { slug: "laparoscopic-appendicectomy-vijayawada", title: "Laparoscopic Appendicectomy", shortDesc: "Emergency and elective appendix removal using minimally invasive techniques.", image: "/images/services/laparoscopic-appendicectomy.webp" },
  { slug: "laser-piles-treatment-vijayawada", title: "Laser Piles Treatment", shortDesc: "Advanced laser treatment for hemorrhoids with minimal pain and same-day discharge.", image: "/images/services/laser-piles-treatment.webp" },
  { slug: "laser-fissure-treatment-vijayawada", title: "Laser Fissure Treatment", shortDesc: "Precise laser treatment for anal fissures ensuring quick healing and minimal discomfort.", image: "/images/services/laser-fissure-treatment.webp" },
  { slug: "laser-fistula-treatment-vijayawada", title: "Laser Fistula Treatment", shortDesc: "Advanced FiLaC laser procedure for anal fistula with sphincter preservation.", image: "/images/services/laser-fistula-treatment.webp" },
  { slug: "thyroid-surgery-vijayawada", title: "Thyroid Surgery", shortDesc: "Expert thyroidectomy for thyroid nodules, goitre, and thyroid cancer.", image: "/images/services/thyroid-surgery.webp" },
  { slug: "varicose-veins-treatment-vijayawada", title: "Varicose Veins Treatment", shortDesc: "Modern endovenous laser treatment for varicose veins with excellent results.", image: "/images/services/varicose-veins-treatment.webp" },
  { slug: "breast-disease-treatment-vijayawada", title: "Breast Disease Treatment", shortDesc: "Comprehensive evaluation and surgical treatment of breast lumps and related conditions.", image: "/images/services/breast-disease-treatment.webp" },
  { slug: "circumcision-vijayawada", title: "Circumcision", shortDesc: "Safe and precise circumcision with modern surgical techniques and quick healing.", image: "/images/services/circumcision.webp" },
  { slug: "swellings-lipoma-abscess-cyst-vijayawada", title: "Swellings — Lipoma / Abscess / Cyst", shortDesc: "Expert removal of lipomas, abscesses, and cysts with minimal scarring.", image: "/images/services/swellings.webp" },
  { slug: "cellulitis-treatment-vijayawada", title: "Cellulitis", shortDesc: "Prompt treatment of skin and soft tissue infections to prevent serious complications.", image: "/images/services/cellulitis.webp" },
  { slug: "ulcer-treatment-vijayawada", title: "Ulcers", shortDesc: "Advanced treatment for chronic non-healing ulcers including diabetic and venous ulcers.", image: "/images/services/ulcers.webp" },
  { slug: "endoscopy-vijayawada", title: "Endoscopy", shortDesc: "Diagnostic and therapeutic upper GI endoscopy for stomach conditions.", image: "/images/services/endoscopy.webp" },
  { slug: "colonoscopy-vijayawada", title: "Colonoscopy", shortDesc: "Comprehensive colonoscopy for colon screening, polyp detection, and treatment.", image: "/images/services/colonoscopy.webp" },
  { slug: "intestinal-surgeries-vijayawada", title: "Intestinal Surgeries", shortDesc: "Expert surgical management of intestinal conditions including obstruction.", image: "/images/services/intestinal-surgeries.webp" },
];

export default function ServicesGrid() {
  return (
    <section id="services" data-testid="services-section" className="py-16 md:py-24" style={{ background: "#f4f8fb" }}>
      <style>{`
        .services-grid-inner {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
        }
        @media (min-width: 768px) {
          .services-grid-inner {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (min-width: 1280px) {
          .services-grid-inner {
            grid-template-columns: repeat(4, 1fr);
          }
        }
        .services-grid-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 24px 16px 20px;
          border-right: 1px solid #e2eaf2;
          border-bottom: 1px solid #e2eaf2;
          text-decoration: none;
          transition: background 0.2s ease;
          background: transparent;
          cursor: pointer;
        }
        @media (min-width: 768px) {
          .services-grid-card { padding: 32px 20px 24px; }
        }
        @media (min-width: 1280px) {
          .services-grid-card { padding: 36px 24px 28px; }
        }
        /* Remove right border on last column per breakpoint */
        @media (max-width: 767px) {
          .services-grid-card:nth-child(2n) { border-right: none; }
          .services-grid-card:nth-last-child(-n+2):nth-child(2n+1),
          .services-grid-card:nth-last-child(1) { border-bottom: none; }
        }
        @media (min-width: 768px) and (max-width: 1279px) {
          .services-grid-card:nth-child(3n) { border-right: none; }
        }
        @media (min-width: 1280px) {
          .services-grid-card:nth-child(4n) { border-right: none; }
        }
      `}</style>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <p className="reveal text-teal font-medium text-sm uppercase tracking-widest mb-3">Our Services</p>
          <h2 className="reveal delay-1 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight">Comprehensive Surgical Solutions</h2>
          <p className="reveal delay-2 text-base md:text-lg text-slate-500 mt-3 max-w-2xl mx-auto">Specialized surgical care across a wide range of procedures, all delivered with precision and compassion.</p>
        </div>

        {/* Grid with divider lines like reference */}
        <div style={{
          background: "#fff",
          borderRadius: 16,
          border: "1px solid #e2eaf2",
          overflow: "hidden",
          boxShadow: "0 2px 24px rgba(31,78,121,0.06)"
        }}>
          <div className="services-grid-inner">
            {SERVICES.map(function(service, i) {
              return (
                <Link
                  key={service.slug}
                  to={"/services/" + service.slug}
                  data-testid={"service-card-" + i}
                  className={"reveal delay-" + (Math.min((i % 4) + 1, 4)) + " group services-grid-card"}
                  onMouseEnter={e => e.currentTarget.style.background = "#f0f8f7"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                >
                  {/* Large icon — no bg, image fills full box */}
                  <div style={{
                    width: 90,
                    height: 90,
                    borderRadius: 18,
                    overflow: "hidden",
                    flexShrink: 0,
                    marginBottom: 20,
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    boxShadow: "0 4px 14px rgba(43,187,173,0.15)",
                  }}
                  className="group-hover:scale-105 group-hover:shadow-lg"
                  >
                    <img
                      src={service.image}
                      alt={service.title}
                      style={{ width: 90, height: 90, objectFit: "cover", display: "block" }}
                      loading="lazy"
                    />
                  </div>

                  {/* Title */}
                  <h3
                    className="font-heading font-semibold group-hover:text-teal transition-colors"
                    style={{ fontSize: 15.5, color: "#0F2A3D", marginBottom: 8, lineHeight: 1.35 }}
                  >
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p style={{ fontSize: 13, color: "#7a8fa3", lineHeight: 1.6, marginBottom: 16, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                    {service.shortDesc}
                  </p>

                  {/* Read More */}
                  <span className="inline-flex items-center gap-1 group-hover:gap-2 transition-all" style={{ fontSize: 13.5, fontWeight: 600, color: "#2BBBAD" }}>
                    Read More <ArrowRight style={{ width: 14, height: 14 }} />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
